module.exports = __webpack_public_path__ + "img/1212d_1.e458a18f.jpg";